import { Link, Outlet } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { fr } from '@/i18n/fr'
import { useLogout, useMe } from '@/api/hooks'

export function Layout() {
  const { data: user } = useMe()
  const logout = useLogout()

  return (
    <div className="min-h-dvh bg-stone-50 text-stone-900 dark:bg-stone-950 dark:text-stone-100">
      <header className="border-b border-stone-200 dark:border-stone-800">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            {fr.app.name}
          </Link>
          {user && (
            <div className="flex items-center gap-2 sm:gap-3">
              {user.is_staff && (
                <a
                  href="/admin/"
                  className="hidden text-sm text-stone-600 hover:underline dark:text-stone-400 sm:inline"
                >
                  {fr.nav.admin}
                </a>
              )}
              <Button variant="ghost" size="sm" onClick={() => logout.mutate()}>
                {fr.nav.logout}
              </Button>
            </div>
          )}
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <Outlet />
      </main>
    </div>
  )
}
